/**
 * InfoOutlineIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const InfoOutlineIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M10.857 17.714h2.286v-6h-2.286zm-.441-9.058a1.714 1.714 0 1 0 3.168-1.312 1.714 1.714 0 0 0-3.168 1.312" />
    <path
      fillRule="evenodd"
      d="M1 12C1 5.925 5.925 1 12 1a11 11 0 0 1 11 11c0 6.075-4.925 11-11 11S1 18.075 1 12m20 0a9 9 0 1 0-18 0 9 9 0 0 0 18 0"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const InfoOutlineIcon = makeIcon('InfoOutlineIcon', InfoOutlineIconSvg)
